var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaused(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33342 16C1.15661 16 0.987037 15.9298 0.862012 15.8047C0.736987 15.6797 0.666748 15.5101 0.666748 15.3333V0.666557C0.666768 0.55071 0.696975 0.436866 0.754393 0.336248C0.811811 0.235631 0.894457 0.151712 0.994186 0.0927628C1.09391 0.033814 1.20728 0.00186991 1.32312 7.96289e-05C1.43895 -0.00171065 1.55325 0.0267146 1.65476 0.0825533L14.9882 7.41594C15.0927 7.47349 15.1799 7.55804 15.2406 7.66076C15.3013 7.76349 15.3333 7.88062 15.3333 7.99994C15.3333 8.11927 15.3013 8.2364 15.2406 8.33912C15.1799 8.44185 15.0927 8.5264 14.9882 8.58395L1.65476 15.9173C1.55632 15.9715 1.44579 16 1.33342 16Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaused);
export default __webpack_public_path__ + "static/media/paused.9d4218ef7231dcfba5e7f94461a80d39.svg";
export { ForwardRef as ReactComponent };